<div class="w-full py-3 px-4">
  <div class="w-full py-3 px-4">
    <!-- Stock Title Section -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center justify-start gap-1 lg:gap-2">
        <img
          class="size-6 sm:size-8 lg:size-10"
          src="/assets/images/stock/stock.png"
          alt="Stock"
        />
        <span class="font-semibold text-sm sm:text-base lg:text-xl text-444"
          >Categories List</span
        >
      </div>

      <div class="flex items-center justify-end gap-3">
        <div class="relative w-[80px] xl:w-[100px] 2xl:w-[120px]">
          <select
            [(ngModel)]="selectedListType"
            (click)="showRelatedList()"
            class="w-full capitalize cursor-pointer border border-c19725 text-c19725 font-bold text-sm sm:text-base rounded-sm py-1 sm:py-2 pl-1.5 sm:pl-2 pr-5 h-[32px] sm:h-[45px] bg-[#FFF7E6] appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-[#C19725]"
          >
            <option value="" disabled selected hidden>list</option>
            <option *ngFor="let type of listTypes" [value]="type">
              {{ type }}
            </option>
          </select>
          <div
            class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none"
          >
            <svg
              class="size-4 sm:size-5"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7942 6.70594L9.00011 13.5L2.20605 6.70595L3.412 5.5L9.00011 11.0881L14.5882 5.5L15.7942 6.70594Z"
                fill="#C19725"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- feature list desktop layout -->
  <table
    class="w-full hidden sm:table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-10"
  >
    <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
      <tr>
        <th
          class="p-3 font-medium text-center border-r border-444 last:border-r-0"
        >
          No.
        </th>
        <th
          class="p-3 font-medium text-left border-r border-444 last:border-r-0"
        >
          Barcode
        </th>
        <th
          class="p-3 font-medium text-center border-r border-444 last:border-r-0"
        >
          Action
        </th>
      </tr>
    </thead>
    <tbody class="text-xs sm:text-sm lg:text-base">
      <tr *ngFor="let item of categoriesData; let i = index">
        <td class="p-3 border-r border-b border-[#D9D9D9] text-center">
          {{ (currentPage - 1) * itemsPerPage + i + 1 }}
        </td>
        <td class="p-3 border-r border-b border-[#D9D9D9]">
          {{ item.name }}
        </td>
        <td class="p-3 border-r border-b border-[#D9D9D9] text-center">
          <div class="flex items-center justify-center gap-2 xl:gap-4">
            <button class="cursor-pointer">
              <svg
                class="size-5 lg:size-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                  stroke="#C19725"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.7166 9.23962L8.10638 15.8499"
                  stroke="#C19725"
                  stroke-miterlimit="5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button class="cursor-pointer">
              <svg
                class="size-5 lg:size-6"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 12.5V17.5"
                  stroke="#BB0000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14 12.5V17.5"
                  stroke="#BB0000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 7.5H20"
                  stroke="#BB0000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                  stroke="#BB0000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                  stroke="#BB0000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div
    class="flex items-center justify-end border-t border-gray-200 bg-white py-3"
  >
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav
          class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs"
          aria-label="Pagination"
        >
          <button
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <button
            (click)="goToPage(1)"
            [class.bg-c19725]="currentPage === 1"
            [class.text-white]="currentPage === 1"
            class="relative z-10 inline-flex items-center justify-center bg-c19725 w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ext-c19725 ring-1 ring-c19725 ring-inset focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725"
          >
            1
          </button>
          <button
            (click)="goToPage(2)"
            [class.bg-c19725]="currentPage === 2"
            [class.text-white]="currentPage === 2"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
          >
            2
          </button>
          <span
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0"
            >...</span
          >
          <button
            (click)="goToPage(10)"
            [class.bg-c19725]="currentPage === 10"
            [class.text-white]="currentPage === 10"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
          >
            10
          </button>
          <button
            (click)="goToNextPage()"
            [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
          >
            <span class="sr-only">Next</span>
            <svg
              class="size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>
